import React from "react";
import { ContentSection } from "sprint-common-web";

import { RecordType } from "../../../../../../common/types/RecordType";
import { FileRecordDetails } from "../../../../../common/file-record-details/FileRecordDetails";
import { AudioFileRecordLanguagesSection } from "./audio/AudioFileRecordLanguagesSection";
import { SubtitleFileRecordLanguagesSection } from "./subtitle/SubtitleFileRecordLanguagesSection";
import { VideoFileRecordLanguagesSection } from "./video/VideoFileRecordLanguagesSection";

interface FileRecordLanguagesSectionProps {
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const FileRecordLanguagesSection = ({
    fileRecordDetails,
    isFileRecordDetailsLoading
}: FileRecordLanguagesSectionProps): JSX.Element => {
    const height = 350;

    switch (fileRecordDetails.type) {
        case RecordType.Video:
            return (
                <VideoFileRecordLanguagesSection
                    fileRecordDetails={fileRecordDetails}
                    isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                    height={height}
                />
            );

        case RecordType.Audio:
            return (
                <AudioFileRecordLanguagesSection
                    fileRecordDetails={fileRecordDetails}
                    isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                    height={height}
                />
            );

        case RecordType.Subtitle:
            return (
                <SubtitleFileRecordLanguagesSection
                    fileRecordDetails={fileRecordDetails}
                    isFileRecordDetailsLoading={isFileRecordDetailsLoading}
                    height={height}
                />
            );

        default:
            return (
                <ContentSection
                    header="File record languages"
                    isLoading={isFileRecordDetailsLoading}
                    testId={"languages-content-section"}
                />
            );
    }
};
